import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"list\">\r\n<path d=\"M6 6L22 6\" stroke=\"#3A3A3A\" stroke-width=\"2\" />\r\n<path d=\"M2 6H4\" stroke=\"#3A3A3A\" stroke-width=\"2\" />\r\n<path d=\"M6 12L22 12\" stroke=\"#3A3A3A\" stroke-width=\"2\" />\r\n<path d=\"M2 12H4\" stroke=\"#3A3A3A\" stroke-width=\"2\" />\r\n<path d=\"M6 18L22 18\" stroke=\"#3A3A3A\" stroke-width=\"2\" />\r\n<path d=\"M2 18H4\" stroke=\"#3A3A3A\" stroke-width=\"2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol